module.exports = __webpack_public_path__ + "static/media/clock-icon.875fdd46.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/clock-icon.svg
// module id = 419
// module chunks = 0